import {multipleSelector_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/multipleSelector_template";
import {filterDate_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDate_template";
import {filterAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterAutoComplete_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import {exportDataCsv} from "../../../vendor/valnet/valnet_jslib/vnHelpers/exportDataCsv";
import {presetFilter_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/presetFilter_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterMultipleAutoComplete_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterMultipleAutoComplete_template";
import {infoButton_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/infoButton_template";
import {filterDropdown_template} from "../../../common/js/vnKnockoutJsTemplates/filterDropdown_template";
import {amCharts_v4_category_line_template} from "./amCharts_v4_category_line_template";
import {amCharts_v4_date_line_template} from "./amCharts_v4_date_line_template";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import {DateAxis, LabelBullet} from "@amcharts/amcharts4/charts";

declare var ko: any;


export class segmentReport_template extends vnTemplate{

    protected brandFilter: filterDropdown_template;
    protected brandSegmentsFilter : multipleSelector_template;
    protected postInitiativesFilter : multipleSelector_template;
    protected postPaymentCategorySystemFilter: multipleSelector_template
    protected postIntentsFilter : multipleSelector_template;
    protected postContentTypesFilter : multipleSelector_template;
    protected articleTypesFilter : multipleSelector_template;
    protected networkCategoriesFilter : multipleSelector_template;
    protected primaryCategoriesFilter: filterMultipleAutoComplete_template;
    protected srEditorsFilter: filterMultipleAutoComplete_template;
    protected jrEditorsFilter: filterMultipleAutoComplete_template;
    protected datesFilter: filterDate_template;
    protected plDatesFilter: filterDate_template;
    protected exportReportDataCsv: exportDataCsv;

    protected chart: amCharts_v4_date_line_template;

    public toolTipActiveSessions: infoButton_template;
    public toolTipActiveRevenue: infoButton_template;
    public toolTipActiveGrossROI: infoButton_template;
    public toolTipRevPL: infoButton_template;

    public validationsList: validationsList_template;
    public presetFilter: presetFilter_template;

    readonly viewModes = [

        {"id": "daily", "name": "Daily"},
        {"id": "profitLoss", "name": "Profit and Loss"},
    ];

    readonly contentTypesGroup : Array<{id : string, name : string}> = [
        { "id": "all", "name": "all"},
        { "id": "shortForm", "name": "Short"},
        { "id": "longForm", "name": "Long"}
    ];

    readonly publishStatus = [
        { "id": "all", "name": "all"},
        { "id": "publish", "name": "publish"},
        { "id": "republish", "name": "republish"}
    ];

    readonly articleTypes : Array<{id : string, name : string}> = [
        {"id": "Regular", "name": "Regular"},
        {"id": "Video", "name": "Video"},
        {"id": "Thread", "name": "Thread"},
    ];

    readonly dataRanges = [
        { "id": 30, "name": "30"},
        { "id": 60, "name": "60"},
        { "id": 90, "name": "90"},
        { "id": 180, "name": "180"},
        { "id": 360, "name": "360"},
        { "id": 720, "name": "720"},
    ];

    protected getTemplateHtml(): string{

        return  `
            <div class="sub-header w-justify">

                ` + this.presetFilter.getHtmlBuild() + `

                <div class="w-left">

                    <div class="dropdown select-single">
                        <label class="form-label" for="">View Mode</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: viewModeSelectedText"></button>
                        <div class="dropdown-list">
                            <div class="w-form">
                                <div class="form-group" data-bind="foreach: viewModes">
                                    <input type="radio" data-bind="checked : $parent.viewModeSelected, value: id,  attr: { 'id': 'view_' + id, 'name' : 'view_' + id }, event:{ change: $parent.onViewModeChange}">
                                    <label class="form-label" data-bind="attr: {for : 'view_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div data-bind="">
                        <label class="form-label" for="" >Brands</label>
                        ${this.brandFilter.getHtmlBuild()}
                    </div>

                    ` + this.brandSegmentsFilter.getHtmlBuild() + `
                    ` + this.postInitiativesFilter.getHtmlBuild() + `
                    ` + this.postIntentsFilter.getHtmlBuild() + `
                    ` + this.postContentTypesFilter.getHtmlBuild() + `
                    ` + this.articleTypesFilter.getHtmlBuild() + `
                    ` + this.networkCategoriesFilter.getHtmlBuild() + `
                    ` + this.postPaymentCategorySystemFilter.getHtmlBuild() + `
                    <div data-bind="visible: viewModeSelected() == 'daily'">
                    ` + this.primaryCategoriesFilter.getHtmlBuild() + `
                    </div>
                    <div data-bind="visible: viewModeSelected() == 'daily'">
                    ` + this.srEditorsFilter.getHtmlBuild() + `
                    </div>
                    <div data-bind="visible: viewModeSelected() == 'daily'">
                    ` + this.jrEditorsFilter.getHtmlBuild() + `
                    </div>
                    <div data-bind="visible: viewModeSelected() == 'daily'">
                    ` + this.datesFilter.getHtmlBuild() + `
                    </div>
                    <div data-bind="visible: viewModeSelected() == 'profitLoss'">
                    ` + this.plDatesFilter.getHtmlBuild() + `
                    </div>

                    <div class="dropdown select-single" data-bind="visible: viewModeSelected() == 'daily'">
                        <label class="form-label" for="">data Range (days)</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: dataRangeSelected"></button>

                        <div class="dropdown-list">
                            <div class="w-form">
                                <div class="form-group" data-bind="foreach: dataRanges">
                                    <input type="radio" data-bind="checked : $parent.dataRangeSelected, value: id,  attr: { 'id': 'data_range_' + id, 'name' : 'data_range_' + id }, event:{ change: $parent.onDataRangeChange}">
                                    <label class="form-label" data-bind="attr: {for : 'data_range_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="content-form-radio">
                        <div class="title" style="font-family:Lato, sans-serif">Form</div>
                        <form >
                            <div style="display: flex; gap:0.5rem" data-bind="foreach: formOptions">
                            <input type="radio" data-bind="checked : $parent.formOptionSelected, value: id,  attr: { 'id': 'form_' + id, 'name' : 'form_' + id }, event:{ change: $parent.onFormOptionChange}">
                            <label class="form-label" data-bind="attr: {for : 'form_' + id }, text: name"></label>
                            </div>
                        </form>
                    </div>

                    <div class="dropdown select-single">
                        <label class="form-label" for="">Publishing type</label>
                        <button class="dropdown-toggle" type="button" data-bind="text: publishStatusSelected"></button>

                        <div class="dropdown-list">
                            <div class="w-form">
                                <div class="form-group" data-bind="foreach: publishStatus">
                                    <input type="radio" data-bind="checked : $parent.publishStatusSelected, value: id,  attr: { 'id': 'pub_status_' + id, 'name' : 'pub_status_' + id }, event:{ change: $parent.onPublishStatusChange}">
                                    <label class="form-label" data-bind="attr: {for : 'pub_status_' + id }, text: name"></label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            ` + this.validationsList.getHtmlBuild()  + `

             <div class="w-filters-selected">
                <div id="filters-selected" class="filters-selected">
                   <div id="selected-brand-segments"></div>
                   <div id="selected-initiatives"></div>
                   <div id="selected-intents"></div>
                   <div id="selected-content_types"></div>
                   <div id="selected-article_types"></div>
                   <div id="selected-network_categories"></div>
                   <div id="selected-systems"></div>
                   <div id="selected-primary_categories" data-bind="visible: viewModeSelected() == 'daily'"></div>
                   <div id="selected-sr-editors" data-bind="visible: viewModeSelected() == 'daily'"></div>
                   <div id="selected-jr-editors" data-bind="visible: viewModeSelected() == 'daily'"></div>
                </div>
            </div>

            <!-- ko if: viewModeSelected() == 'daily' -->
                <div class="list-header w-justify">
                    <div class="w-left">
                        <h2 class="section-title icon i-roi">Segment Report</h2>
                        <div>
                            <label class="toggle">
                                <span class="toggle-label" data-bind="css: (trafficSource() == 1) ? 'is-activated' : ''">GA4</span>
                                <input class="toggle-checkbox" data-bind="event: {change: onToggleTrafficSource}, checked: (trafficSource() == 2)" type="checkbox">
                                <div class="toggle-switch"></div>
                                <span class="toggle-label" data-bind="css: (trafficSource() == 2) ? 'is-activated' : ''">Sentinel</span>
                            </label>
                        </div>
                    </div>
                </div>

                <section class="w-graph segment-report" data-bind="css: { loading: isGraphLoading }" style="">
                    <div class="graph">
                        <div class="graph-title">Active Sessions by Segment</div>
                        ` + this.chart.getHtmlBuild() + `
                    </div>

                    <div class="graph">
                        <div class="graph-title">Active Sessions Share by Segment</div>
                        <div id="segmentPieChart" class="segment-pie-chart"></div>
                    </div>
                </section>

                <div class="list-header w-justify">
                    <div class="w-right">
                        <button class="btn highlight icon fix-width i-expand" type="button" data-bind="class:  collapseButtonClass(), css: {'is-hidden': collapseButtonHidden()} , text: collapseButtonText(), event: { click: onCollapseClick}">Simplify</button>
                        <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportData}, css: { 'is-hidden': exportButtonHidden(), 'is-loading': exportDataButtonClickable() == false  }">Export</button>
                    </div>
                </div>

                <div class="w-list-results segment-report" id="list-results" style="padding-bottom: 200px">

                    <table class="list-results list-sections thin no-shadow">
                        <thead>
                            <tr class="header list-header-section no-shadow">
                                <th class="start" data-bind="attr: { colspan: 1 }"><span></span></th>
                                <!-- ko if: segmentHeaders().length > 0 -->
                                    <th class="colgroup-1 start" data-bind="attr: { colspan: segmentHeaders().length }"><span>Segment</span></th>
                                <!-- /ko -->
                                <th class="colgroup-4 start" data-bind="attr: { colspan: overviewSectionColumnCount }"><span>Overview</span></th>
                            </tr>
                            <tr class="header flex-end-span">
                                <th class="align-right end min-width"><span>Day</span></th>

                                <!-- Segment headers -->
                                <!-- ko foreach: segmentHeaders() -->
                                    <th data-bind="attr: { class: ($index() == 0) ? 'align-right colgroup-1 start' : 'align-right colgroup-1'}"><span data-bind="text: segmentName"></span></th>
                                <!-- /ko -->

                                <!-- Overview headers -->
                                <th class="align-right colgroup-4 start"><span>Art.</span></th>
                                <th class="align-right colgroup-4"><span>Act. Sess./Art.</span></th>
                                <th class="align-right colgroup-4">
                                    <div style="display: flex;align-items: center; padding: 0;position: relative;justify-content: flex-end;" >
                                        <span>Act. Revenue</span>
                                        <div class="w-tooltips-adv auto-height short pos-last">
                                            ` + this.toolTipActiveRevenue.getHtmlBuild() + `
                                        </div>
                                    </div>
                                </th>
                                <th class="align-right colgroup-4"><span>SV</span></th>
                                <th class="align-right colgroup-4"><span>Rev./Art.</span></th>
                                <th class="align-right colgroup-4" data-bind="visible: collapseButtonText() == 'simplify'"><span>Writer Cost</span></th>
                                <th class="align-right colgroup-4" data-bind="visible: collapseButtonText() == 'simplify'"><span>Editor Cost</span></th>
                                <th class="align-right colgroup-4" data-bind="visible: collapseButtonText() == 'simplify'"><span>Other Content Cost</span></th>
                                <th class="align-right colgroup-4"><span>Total Cost</span></th>
                                <th class="align-right colgroup-4"><span>C/A</span></th>
                                <th class="align-right colgroup-4"><span>GP/A</span></th>
                                <th class="align-right colgroup-4">
                                    <div style="display: flex;align-items: center; padding: 0;position: relative;justify-content: flex-end;" >
                                        <span>
                                            Act. Gross ROI%
                                        </span>
                                        <div class="w-tooltips-adv pos-last auto-height short">
                                        ` + this.toolTipActiveGrossROI.getHtmlBuild() + `
                                        </div>
                                    </div>
                                </th>
                                <th class="align-right colgroup-4"><span>Act. Pageviews.</span></th>
                                <th class="align-right colgroup-4">
                                    <div style="display: flex;align-items: center; padding: 0;position: relative;justify-content: flex-end;" >
                                        <span>Act. Sess.</span>
                                        <div class="w-tooltips-adv auto-height short pos-last">
                                            ` + this.toolTipActiveSessions.getHtmlBuild() + `
                                        </div>
                                    </div>
                                </th>
                                <th class="align-right colgroup-4"><span>PG/S</span></th>
                            </tr>
                        </thead>
                        <tbody>

                            <!-- ko foreach: reportData() -->
                                <tr data-bind="event: { click: $parent.onClickRowClick.bind($data, $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf($index()) !== -1}">
                                    <td class="align-right start end"><span data-bind="text: Day"></span></td>

                                    <!-- Segment -->
                                    <!-- ko foreach: segmentData -->
                                            <td data-bind="attr: { class: ($index() == 0) ? 'align-right colgroup-1 start' : 'align-right colgroup-1'}"><span data-bind="text: '$' + Number(activeRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <!-- /ko -->

                                    <!-- Overview -->
                                    <td class="align-right colgroup-4 start"><span data-bind="text: Number(articleCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: Number(activeSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: '$' + Number(activeRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: '$' + Number(sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: '$' + Number(revenuePerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4 darken" data-bind="visible: $parent.collapseButtonText() == 'simplify'"><span data-bind="text: '$' + Number(writerCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4 darken" data-bind="visible: $parent.collapseButtonText() == 'simplify'"><span data-bind="text: '$' + Number(editorCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4 darken" data-bind="visible: $parent.collapseButtonText() == 'simplify'"><span data-bind="text: '$' + Number(otherContentCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: '$' + Number(totalCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: '$' + Number(costPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: '$' + Number(grossProfitPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}), attr: { class: Number(grossProfitPerArticle) < 0 ? 'negative' : ''}"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: Number(activeGrossROI).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%', attr: { class: Number(activeGrossROI) < 0 ? 'negative' : ''}"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: Number(activePageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: Number(activeSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: Number(pageviewsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                </tr>
                            <!-- /ko -->

                            <!-- ko foreach: reportTotalsData() -->
                                <tr class="total" data-bind="event: { click: $parent.onClickRowClick.bind($data, 'total' + $index(), $data) }, css: { 'is-clicked': $parent.selectedRows().indexOf('total' + $index()) !== -1}">
                                    <td class="align-right start end"><span data-bind="text: Day"></span></td>

                                    <!-- Segment -->
                                    <!-- ko foreach: segmentData -->
                                            <td data-bind="attr: { class: ($index() == 0) ? 'align-right colgroup-1 start' : 'align-right colgroup-1'}"><span data-bind="text: '$' + Number(activeRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <!-- /ko -->

                                    <!-- Overview -->
                                    <td class="align-right colgroup-4 start"><span data-bind="text: Number(articleCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: Number(activeSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: '$' + Number(activeRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: '$' + Number(sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: '$' + Number(revenuePerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4 darken" data-bind="visible: $parent.collapseButtonText() == 'simplify'"><span data-bind="text: '$' + Number(writerCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4 darken" data-bind="visible: $parent.collapseButtonText() == 'simplify'"><span data-bind="text: '$' + Number(editorCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4 darken" data-bind="visible: $parent.collapseButtonText() == 'simplify'"><span data-bind="text: '$' + Number(otherContentCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: '$' + Number(totalCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: '$' + Number(costPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: '$' + Number(grossProfitPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2}), attr: { class: Number(grossProfitPerArticle) < 0 ? 'negative' : ''}"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: Number(activeGrossROI).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%', attr: { class: Number(activeGrossROI) < 0 ? 'negative' : ''} "></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: Number(activePageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: Number(activeSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <td class="align-right colgroup-4"><span data-bind="text: Number(pageviewsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                </tr>
                            <!-- /ko -->
                        </tbody>
                    </table>
                </div>
            <!-- /ko -->

            <!-- ko if: viewModeSelected() == 'profitLoss' -->
                <div class="list-header w-justify">
                    <div class="w-left">
                        <h2 class="section-title icon i-roi">Segment P&L Report</h2>
                    </div>
                </div>

                <div class="list-header w-justify">
                    <div class="w-right">
                        <button class="btn icon highlight i-export" type="button" data-bind="event: { click: exportData}, css: { 'is-hidden': exportButtonHidden(), 'is-loading': exportDataButtonClickable() == false  }">Export</button>
                    </div>
                </div>

                <div class="w-list-results segment-pl-report" id="list-pl-results">
                    <!-- ko if: !plReportData() || plReportData().length == 0 -->
                        <div><span>No data available.</span></div>
                    <!-- /ko -->
                    <!-- ko if: plReportData() && plReportData().length > 0 -->
                        <table class="list-results list-sections thin no-shadow">
                            <thead>
                                <tr class="header list-header-section no-shadow">
                                    <th class="group single start end""><span></span></th>
                                    <!-- ko foreach: plReportData() -->
                                        <th class="colgroup-1 start"><span style="justify-content: center;" data-bind="text: segmentName"></span></th>
                                    <!-- /ko -->
                                </tr>
                            </thead>
                            <tbody style="text-align: right">

                                <tr data-bind="event: { click: onClickRowClick.bind($data, 0, $data) }, css: { 'is-clicked': selectedRows().indexOf(0) !== -1}">
                                    <td class="group single start end">
                                        <span>
                                            Revenue
                                            <span class="w-tooltips-adv auto-height short pos-right">
                                                ` + this.toolTipRevPL.getHtmlBuild() + `
                                            </span>     
                                        </span>                                   
                                    </td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: '$' + Number(revenue).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                        </td>
                                    <!-- /ko -->
                                </tr>
                                <tr>
                                    <td class="group single start end"></td>
                                    <td colspan="100%">&nbsp;</td>
                                </tr>

                                <tr data-bind="event: { click: onClickRowClick.bind($data, 1, $data) }, css: { 'is-clicked': selectedRows().indexOf(1) !== -1}">
                                    <td class="group single start end"><span>Writer Cost</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: '$' + Number(writerCost).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <!-- /ko -->
                                </tr>

                                <tr data-bind="event: { click: onClickRowClick.bind($data, 2, $data) }, css: { 'is-clicked': selectedRows().indexOf(2) !== -1}">
                                    <td class="group single start end"><span>Editor Cost</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: '$' + Number(editorCost).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <!-- /ko -->
                                </tr>

                                <tr data-bind="event: { click: onClickRowClick.bind($data, 3, $data) }, css: { 'is-clicked': selectedRows().indexOf(3) !== -1}">
                                    <td class="group single start end"><span>Other Content Cost</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: '$' + Number(otherContentCost).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <!-- /ko -->
                                </tr>

                                <tr data-bind="event: { click: onClickRowClick.bind($data, 4, $data) }, css: { 'is-clicked': selectedRows().indexOf(4) !== -1}">
                                    <td class="group single start end"><span>Gross Profit</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td class="border-top"><span data-bind="text: '$' + Number(grossProfit).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}), attr: { class: Number(grossProfit) < 0 ? 'negative' : ''}"></span></td>
                                    <!-- /ko -->
                                </tr>

                                <tr data-bind="event: { click: onClickRowClick.bind($data, 5, $data) }, css: { 'is-clicked': selectedRows().indexOf(5) !== -1}">
                                    <td class="group single start end"><span>Gross Margin %</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: Number(grossMarginPercentage).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%', attr: { class: Number(grossMarginPercentage) < 0 ? 'negative' : ''}"></span></td>
                                    <!-- /ko -->
                                </tr>
                                <tr>
                                    <td class="group single start end"></td>
                                    <td colspan="100%">&nbsp;</td>
                                </tr>
                                <tr data-bind="event: { click: onClickRowClick.bind($data, 6, $data) }, css: { 'is-clicked': selectedRows().indexOf(6) !== -1}">
                                    <td class="group single start end"><span>Share of Segment Revenue</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: Number(shareSegmentRevenue).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%'"></span></td>
                                    <!-- /ko -->
                                </tr>

                                <tr data-bind="event: { click: onClickRowClick.bind($data, 7, $data) }, css: { 'is-clicked': selectedRows().indexOf(7) !== -1}">
                                    <td class="group single start end"><span>Share of Segment Profit</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: Number(shareSegmentProfit).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%', attr: { class: Number(shareSegmentProfit) < 0 ? 'negative' : ''}"></span></td>
                                    <!-- /ko -->
                                </tr>
                                <tr>
                                    <td class="group single start end"></td>
                                    <td colspan="100%">&nbsp;</td>
                                </tr>
                                <tr data-bind="event: { click: onClickRowClick.bind($data, 8, $data) }, css: { 'is-clicked': selectedRows().indexOf(8) !== -1}">
                                    <td class="group single start end"><span>Output</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: Number(articleCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <!-- /ko -->
                                </tr>

                                <tr data-bind="event: { click: onClickRowClick.bind($data, 9, $data) }, css: { 'is-clicked': selectedRows().indexOf(9) !== -1}">
                                    <td class="group single start end"><span>Daily Output</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: Number(dailyOutput).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <!-- /ko -->
                                </tr>

                                <tr data-bind="event: { click: onClickRowClick.bind($data, 10, $data) }, css: { 'is-clicked': selectedRows().indexOf(10) !== -1}">
                                    <td class="group single start end"><span>Daily Sessions</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: Number(dailySessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0})"></span></td>
                                    <!-- /ko -->
                                </tr>

                                <tr data-bind="event: { click: onClickRowClick.bind($data, 11, $data) }, css: { 'is-clicked': selectedRows().indexOf(11) !== -1}">
                                    <td class="group single start end"><span>Failure Rate</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <!-- <td><span data-bind="text: Number(failureRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%'"></span></td> -->


                                        <td class="align-right" data-bind="attr: {title: 'Failure rate based on ' + (Number(isPassedCount) + Number(isFailureCount)) + ' articles out of ' + (Number(isPassedCount) + Number(isFailureCount) + Number(isPendingCount)) + '.'}, css: { 'is-empty': Number(isPendingCount) == 0 && Number(isPassedCount) == 0 && Number(isFailureCount) == 0, 'is-pending': Number(isPendingCount) > 0 && Number(isPassedCount) == 0 && Number(isFailureCount) == 0, 'is-pending': Number(isPendingCount) > 0 && (Number(isPassedCount) > 0 || Number(isFailureCount) > 0) }">
                                            <!-- ko if: ($parent.publishStatusSelected() == 'publish' || $parent.publishStatusSelected() == 'all') -->
                                                <span style="margin-left: 2rem;" data-bind="text: (failureRate != null) ? Number(failureRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%' : ''"></span>
                                            <!-- /ko -->
                                        </td>
                                    <!-- /ko -->
                                </tr>
                                <tr>
                                    <td class="group single start end"></td>
                                    <td colspan="100%">&nbsp;</td>
                                </tr>
                                <tr data-bind="event: { click: onClickRowClick.bind($data, 12, $data) }, css: { 'is-clicked': selectedRows().indexOf(12) !== -1}">
                                    <td class="group single start end"><span>SV</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: '$' + Number(sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <!-- /ko -->
                                </tr>

                                <tr data-bind="event: { click: onClickRowClick.bind($data, 13, $data) }, css: { 'is-clicked': selectedRows().indexOf(13) !== -1}">
                                    <td class="group single start end"><span>C/A</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: '$' + Number(costPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2})"></span></td>
                                    <!-- /ko -->
                                </tr>

                                <tr data-bind="event: { click: onClickRowClick.bind($data, 14, $data) }, css: { 'is-clicked': selectedRows().indexOf(14) !== -1}">
                                    <td class="group single start end"><span>ROI</span></td>
                                    <!-- ko foreach: plReportData() -->
                                        <td><span data-bind="text: Number(grossROI).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%', attr: { class: Number(grossROI) < 0 ? 'negative' : ''}"></span></td>
                                    <!-- /ko -->
                                </tr>
                            </tbody>
                        </table>
                    <!-- /ko -->
                </div>
            <!-- /ko -->
        `;
    }

    protected initPartial():void{

        this.presetFilter = new presetFilter_template("presetFilter", this.getTemplateViewModel(), this.caller);
        this.presetFilter.setType('segmentReport');

        this.brandFilter = new filterDropdown_template("brandFilter", this.getTemplateViewModel(), this.caller);

        this.brandSegmentsFilter = new multipleSelector_template("brandSegmentsFilter", this.getTemplateViewModel(), this.caller);
        this.brandSegmentsFilter.setTagContainerId('selected-brand-segments');
        this.brandSegmentsFilter.setTagContainerCaption('Selected segments:');
        this.brandSegmentsFilter.setLabel("segments");
        this.brandSegmentsFilter.setLogoEnabled(false);

        this.postInitiativesFilter = new multipleSelector_template("postInitiativesFilter", this.getTemplateViewModel(), this.caller);
        this.postInitiativesFilter.setLabel("Mappings");
        this.postInitiativesFilter.setFilterContainerClass('margin-neg');
        this.postInitiativesFilter.setTagContainerId('selected-initiatives');
        this.postInitiativesFilter.setTagContainerCaption('Selected mappings:');

        this.postPaymentCategorySystemFilter = new multipleSelector_template("postPaymentCategorySystemFilter", this.getTemplateViewModel(), this.caller);
        this.postPaymentCategorySystemFilter.setLabel("System");
        this.postPaymentCategorySystemFilter.setFilterContainerClass('margin-neg');
        this.postPaymentCategorySystemFilter.setTagContainerId('selected-systems');
        this.postPaymentCategorySystemFilter.setTagContainerCaption('Selected systems:');

        this.postIntentsFilter = new multipleSelector_template("postIntentsFilter", this.getTemplateViewModel(), this.caller);
        this.postIntentsFilter.setLabel("Intents");
        this.postIntentsFilter.setFilterContainerClass('margin-neg');
        this.postIntentsFilter.setTagContainerId('selected-intents');
        this.postIntentsFilter.setTagContainerCaption('Selected intents:');

        this.postContentTypesFilter = new multipleSelector_template("postContentTypesFilter", this.getTemplateViewModel(), this.caller);
        this.postContentTypesFilter.setLabel("content types");
        this.postContentTypesFilter.setTagContainerId('selected-content_types');
        this.postContentTypesFilter.setTagContainerCaption('Selected content types:');

        this.articleTypesFilter = new multipleSelector_template("articleTypesFilter", this.getTemplateViewModel(), this.caller);
        this.articleTypesFilter.setLabel("page types");
        this.articleTypesFilter.setTagContainerId('selected-article_types');
        this.articleTypesFilter.setTagContainerCaption('Selected page types:');

        this.networkCategoriesFilter = new multipleSelector_template("networkCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.networkCategoriesFilter.setLabel("network categories");
        this.networkCategoriesFilter.setTagContainerId('selected-network_categories');
        this.networkCategoriesFilter.setTagContainerCaption('Selected network categories:');

        this.primaryCategoriesFilter = new filterMultipleAutoComplete_template("primaryCategoriesFilter", this.getTemplateViewModel(), this.caller);
        this.primaryCategoriesFilter.setIsVisible(1);
        this.primaryCategoriesFilter.setPlaceHolderText("Primary Category");
        this.primaryCategoriesFilter.setIcon("i-tag-a");
        this.primaryCategoriesFilter.setTagContainerId('selected-primary_categories');
        this.primaryCategoriesFilter.setTagContainerCaption('Selected Primary Categories:');
        this.primaryCategoriesFilter.setMinInputSuggestionLength(2);

        this.srEditorsFilter = new filterMultipleAutoComplete_template("srEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.srEditorsFilter.setIsVisible(1);
        this.srEditorsFilter.setPlaceHolderText("Sr Editor");
        this.srEditorsFilter.setIcon("i-user2");
        this.srEditorsFilter.setTagContainerId('selected-sr-editors');
        this.srEditorsFilter.setTagContainerCaption('Selected Sr Editors:');
        this.srEditorsFilter.setMinInputSuggestionLength(2);

        this.jrEditorsFilter = new filterMultipleAutoComplete_template("jrEditorsFilter", this.getTemplateViewModel(), this.caller);
        this.jrEditorsFilter.setIsVisible(1);
        this.jrEditorsFilter.setPlaceHolderText("Jr Editor");
        this.jrEditorsFilter.setIcon("i-user2");
        this.jrEditorsFilter.setTagContainerId('selected-jr-editors');
        this.jrEditorsFilter.setTagContainerCaption('Selected Jr Editors:');
        this.jrEditorsFilter.setMinInputSuggestionLength(2);

        this.initializeToolTips();

        this.datesFilter = new filterDate_template("datesFilter", this.getTemplateViewModel(), this.caller);
        this.datesFilter.setStartPickerId('startDate');
        this.datesFilter.setEndPickerId('endDate');

        let date = new Date();
        date.setHours(0,0,0,0);
        let mm = date.getMonth() + 1;

        date.setDate(date.getDate() - 1);

        let startDate = new Date();
        startDate.setHours(0,0,0,0);
        startDate.setDate(date.getDate() - 30);

        this.datesFilter.setDateRange(startDate, date);

        this.plDatesFilter = new filterDate_template("plDatesFilter", this.getTemplateViewModel(), this.caller);
        this.plDatesFilter.setStartPickerId('plStartDate');
        this.plDatesFilter.setEndPickerId('plEndDate');

        let plDate = new Date();
        plDate.setHours(0,0,0,0);
        let firstOfMonth = new Date(plDate.getFullYear(),date.getMonth(), 1);

        // if it is the first day of the month, we display data from the last month
        if(plDate.getTime() === firstOfMonth.getTime()){
            firstOfMonth = new Date(plDate.getFullYear(),plDate.getMonth() - 1, 1);
            plDate.setDate(plDate.getDate() - 1);
        }else{
            plDate.setDate(plDate.getDate() - 1);
        }

        this.plDatesFilter.setDateRange(firstOfMonth, plDate);

        this.chart = new amCharts_v4_date_line_template("segmentReportChart", this.getTemplateViewModel(), this.caller);
        this.chart.setCssHeight(320);

        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);

        this.exportReportDataCsv = new exportDataCsv();

        let toolTipRevPLContent = `
            <p>This is calculated using the revenue available in the Audience Value Tool, with a multiplier applied to each segment based on the ratio of revenue available in the Audience Value Tool for a brand, compared to that brand\’s total revenue represented on the Revenue Sheet</p>
            <p>(Total Brand Revenue Sheet Revenue / Total Brand AVT Revenue) * AVT Segment Revenue</p>
        `;
        this.toolTipRevPL = new infoButton_template('toolTipRevPL', this.getTemplateViewModel(), this.caller)
        this.toolTipRevPL.setTitle('Estimated Total Segment Revenue');
        this.toolTipRevPL.setContent(toolTipRevPLContent);        
    }

    protected initializeToolTips(): void {

        if (this.toolTipActiveSessions === undefined){

            this.toolTipActiveSessions = new infoButton_template('toolTipActiveSessions', this.getTemplateViewModel(), this.caller)
            this.toolTipActiveSessions.setTitle('Active Sessions');
        }

        let toolTipActiveSessionsContent = "<p>Total sessions for articles published in the chosen date range within the first " + this.getTemplateViewModel().dataRangeSelected() + " days of being published.</p>";
        toolTipActiveSessionsContent = toolTipActiveSessionsContent + "<p>Data for each day will continue to accumulate daily up until " + this.getTemplateViewModel().dataRangeSelected() + " days.</p>";
        this.toolTipActiveSessions.setContent(toolTipActiveSessionsContent);

        if (this.toolTipActiveRevenue === undefined){

            this.toolTipActiveRevenue = new infoButton_template('toolTipActiveRevenue', this.getTemplateViewModel(), this.caller)
            this.toolTipActiveRevenue.setTitle('Active Revenue');
        }

        let toolTipActiveRevenueContent = "<p>Total revenue generated by active sessions on articles published within the selected date range during their first " + this.getTemplateViewModel().dataRangeSelected() + " days of being published.</p>";
        toolTipActiveRevenueContent = toolTipActiveRevenueContent + "<p>Data for each day will continue to accumulate daily up until " + this.getTemplateViewModel().dataRangeSelected() + " days.</p>";
        this.toolTipActiveRevenue.setContent(toolTipActiveRevenueContent);

        if (this.toolTipActiveGrossROI === undefined){

            let toolTipActiveGrossROIContent = "<p>Calculated as (Active Revenue - Total Cost) / (Total Cost) * 100</p>";
            this.toolTipActiveGrossROI = new infoButton_template('toolTipActiveGrossROI', this.getTemplateViewModel(), this.caller)
            this.toolTipActiveGrossROI.setTitle('Active Gross ROI%');
            this.toolTipActiveGrossROI.setContent(toolTipActiveGrossROIContent);
        }
    }

    protected getTemplateName(): string{

        return "segmentReport_template";
    }

    protected getMainElementClasses(): Array<string> {

        return [];
    }


    protected buildViewModel(): any {

        // define the viewmodel data/ functions
        let huit_neuf_this = this;

        return {
            viewModes                   : ko.observableArray([]),
            viewModeSelected            : ko.observable("daily"),
            viewModeSelectedText        : ko.observable("Daily"),
            isGraphLoading              : ko.observable(0),
            segmentHeaders              : ko.observableArray([]),
            reportData                  : ko.observableArray([]),
            reportTotalsData            : ko.observableArray([]),
            plReportData                : ko.observableArray([]),
            formOptions                 : ko.observableArray([]),
            formOptionSelected          : ko.observable("all"),
            allBrandSegments            : ko.observableArray([]),
            dataRanges                  : ko.observableArray([]),
            dataRangeSelected           : ko.observable(30),
            exportDataButtonClickable   : ko.observable(1),
            overviewSectionColumnCount  : ko.observable(1),
            collapseButtonHidden        : ko.observable(1),
            collapseButtonClass         : ko.observable("i-expand"),
            collapseButtonText          : ko.observable("expand"),
            exportButtonHidden          : ko.observable(1),
            trafficSource               : ko.observable(2),
            selectedRows                : ko.observableArray([]),
            publishStatus               : ko.observableArray([]),
            publishStatusSelected       : ko.observable("all"),
            onFormOptionChange          : function(data) {huit_neuf_this.onFormOptionChange(data); },
            onDataRangeChange           : function(data) {huit_neuf_this.onDataRangeChange(data); },
            onCollapseClick             : function(){ huit_neuf_this.onCollapseClick(); },
            exportData                  : function(){ huit_neuf_this.exportData(); },
            onToggleTrafficSource       : function(data, event){ huit_neuf_this.onToggleTrafficSource(data, event);},
            onClickRowClick             : function(index, data){ huit_neuf_this.onClickRowClick(index); return true; },
            onPublishStatusChange       : function(data){ huit_neuf_this.onPublishStatusChange(); },
            onViewModeChange            : function (data) {huit_neuf_this.onViewModeChange(data); },
        };
    }

    public onToggleTrafficSource(data, event){

        let toggleValue = this.getTemplateViewModel().trafficSource();

        if (toggleValue == 2) {

            this.getTemplateViewModel().trafficSource(1); // GA4 = 1
        }else {

            this.getTemplateViewModel().trafficSource(2); // Sentinel = 2
        }

        this.caller.getListData();
    }

    public getViewModelForRequest(){

        return {
            brand: this.brandFilter.getTemplateViewModel().selectedOption(),
            brandSegments: this.getTemplateViewModel().brandSegmentsFilter.selectedItems(),
            postInitiatives: this.getTemplateViewModel().postInitiativesFilter.selectedItems(),
            postPaymentCategorySystems: this.getTemplateViewModel().postPaymentCategorySystemFilter.selectedItems(),
            postIntents: this.getTemplateViewModel().postIntentsFilter.selectedItems(),
            postContentTypes: this.getTemplateViewModel().postContentTypesFilter.selectedItems(),
            articleTypes: this.getTemplateViewModel().articleTypesFilter.selectedItems(),
            networkCategories: this.getTemplateViewModel().networkCategoriesFilter.selectedItems(),
            idPrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemIds(),
            namePrimaryCategories: this.getTemplateViewModel().primaryCategoriesFilter.selectedItemNames(),
            srEditors: this.getTemplateViewModel().srEditorsFilter.selectedItemIds(),
            srEditorNames: this.getTemplateViewModel().srEditorsFilter.selectedItemNames(),
            jrEditors: this.getTemplateViewModel().jrEditorsFilter.selectedItemIds(),
            jrEditorNames: this.getTemplateViewModel().jrEditorsFilter.selectedItemNames(),
            dateFilterType: this.getTemplateViewModel().datesFilter.selectedFilter(),
            startDate: this.getTemplateViewModel().datesFilter.startDate(),
            endDate: this.getTemplateViewModel().datesFilter.endDate(),
            startDateRange: this.getTemplateViewModel().datesFilter.fromRange(),
            endDateRange: this.getTemplateViewModel().datesFilter.toRange(),
            plDateFilterType: this.getTemplateViewModel().plDatesFilter.selectedFilter(),
            plStartDate: this.getTemplateViewModel().plDatesFilter.startDate(),
            plEndDate: this.getTemplateViewModel().plDatesFilter.endDate(),
            plStartDateRange: this.getTemplateViewModel().plDatesFilter.fromRange(),
            plEndDateRange: this.getTemplateViewModel().plDatesFilter.toRange(),
            postContentTypesGroup: this.getTemplateViewModel().formOptionSelected(),
            dataRange: this.getTemplateViewModel().dataRangeSelected(),
            trafficSource: this.getTemplateViewModel().trafficSource(),
            viewMode: this.getTemplateViewModel().viewModeSelected(),
            viewModeText: this.getTemplateViewModel().viewModeSelectedText(),
            publishStatus: this.getTemplateViewModel().publishStatusSelected(),
        }
    }

    public build(classesToAdd: Array<string> = []): HTMLElement {

        return super.build(classesToAdd);
    }

    public buildDatePickerCalendar(){

        this.datesFilter.buildCalendar();
        this.plDatesFilter.buildCalendar();
    }

    public setBrandFilterItems(brands) {

        this.brandFilter.setOptions(brands);
        this.brandFilter.setLabel("Brands");
    }

    public setPublishStatusItems(){

        this.getTemplateViewModel().publishStatus(this.publishStatus);
    }

    public setAllBrandSegments(brandSegments){

        this.getTemplateViewModel().allBrandSegments(brandSegments);
    }

    public setBrandSegments(resetSegments = true){

        let brandSegments = this.getTemplateViewModel().allBrandSegments();
        let selectedBrand = this.brandFilter.getTemplateViewModel().selectedOption();

        if (resetSegments){

            this.presetFilter.setMultiSelectorPresetFilters(this.brandSegmentsFilter, []);
        }

        let segments = [];
        segments.unshift({id: 0, name: 'no segments'});

        for (let brand of brandSegments){

            if (brand.id != selectedBrand){

                continue;
            }

            for( let segment of brand.segments){

                segments.push(segment);
            }

            break;
        }

        this.brandSegmentsFilter.setItems(segments);
        this.brandSegmentsFilter.setLabel('Segments');
    }

    public setPostInitiativesFilterItems(items){

        for (let item of items){

            item['name'] = item['initiative'];
        }
        items.unshift({'id': 0, 'name' : 'no mappings'});
        this.postInitiativesFilter.setItems(items);
    }

    public setPostPaymentCategorySystemFilterItems(items){

        for (let item of items){

            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no systems'});
        this.postPaymentCategorySystemFilter.setItems(items);
    }

    public setPostIntentsFilterItems(items){

        for (let item of items){

            item['name'] = item['name'];
        }
        items.unshift({'id': 0, 'name' : 'no intents'});
        this.postIntentsFilter.setItems(items);
    }

    public setPostContentTypesFilterItems(items){

        items.unshift({id: 0, name: 'no post types', contentTypes: [{id: 0, name: 'no post types'}]});

        let groups = [];
        for (let groupedContentType of items){

            let group = {"name" : groupedContentType.name, "items" : groupedContentType.contentTypes};
            groups.push(group);
        }

        this.postContentTypesFilter.setMultiSectionItems(groups);
        this.postContentTypesFilter.setLabel('Content Types');
    }

    public setArticleTypesFilterItems(){

        this.articleTypesFilter.setItems(this.articleTypes);
        this.articleTypesFilter.setSelectedItems([{id: 'Regular'}]);
        this.articleTypesFilter.setTags(['Regular'], this.articleTypesFilter.getItems());
    }

    public setNetworkCategoriesFilterItems(items){

        items.unshift({id: 0, name: 'no network categories', networkCategories: [{id: 0, name: 'no network categories'}]});

        let groups = [];
        for (let groupedNetworkCategory of items){

            let group = {"name" : groupedNetworkCategory.name, "items" : groupedNetworkCategory.networkCategories};
            groups.push(group);
        }

        this.networkCategoriesFilter.setMultiSectionItems(groups);
        this.networkCategoriesFilter.setLabel('Network Categories');
    }

    public setReportData(reportData){

        this.showExportButton();
        this.calculateColumnCount()

        this.getTemplateViewModel().reportData(reportData.reportData);
        this.getTemplateViewModel().segmentHeaders(reportData.segmentHeaders);
        this.getTemplateViewModel().reportTotalsData(reportData.reportTotalsData);
    }

    public setPlReportData(plReportData){

        this.showExportButton();
        this.getTemplateViewModel().plReportData(plReportData);
    }

    private onCollapseClick(){

        if(this.getTemplateViewModel().collapseButtonText() == 'simplify'){

            this.getTemplateViewModel().collapseButtonClass('i-expand');
            this.getTemplateViewModel().collapseButtonText('expand');
        }else{

            this.getTemplateViewModel().collapseButtonClass('i-simplify');
            this.getTemplateViewModel().collapseButtonText('simplify');
        }

        this.calculateColumnCount();
    }

    public setPostContentTypesGroupFilterItems(){

        this.getTemplateViewModel().formOptions(this.contentTypesGroup);
    }

    private exportData(){

        let check = this.getTemplateViewModel().exportDataButtonClickable();
        if (check) {

            if(this.getTemplateViewModel().viewModeSelected() == 'daily'){

                this.getTemplateViewModel().exportDataButtonClickable(0);
                this.caller.getCsvExportData();
            } else if(this.getTemplateViewModel().viewModeSelected() == 'profitLoss'){

                this.getTemplateViewModel().exportDataButtonClickable(0);
                this.caller.getCsvExportPlData();
            }
        }
    }

    private setExportData(reportData){

        let exportDataView = [];
        for (let exportDataRow of reportData.reportData) {

            let exportDataViewRow = this.getFormatedExportRow(exportDataRow);
            exportDataView.push(exportDataViewRow);
        }

        for (let exportDataRow of reportData.reportTotalsData) {

            let exportDataViewRow = this.getFormatedExportRow(exportDataRow);
            exportDataView.push(exportDataViewRow);
        }

        let fileName = "segmentReport_data_from_" + this.datesFilter.getTemplateViewModel().startDate() + "_to_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportReportDataCsv.exportToCsv(fileName, exportDataView);

        this.getTemplateViewModel().exportDataButtonClickable(1);
    }

    private setExportPlData(reportData){

        let exportDataView = [];
        let exportDataViewRow = [];

        exportDataViewRow[""] = '';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = exportDataRow.segmentName;
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'Revenue';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = '$' + Number(exportDataRow.revenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'Writer Cost';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = '$' + Number(exportDataRow.writerCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'Editor Cost';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = '$' + Number(exportDataRow.editorCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'Other Content Cost';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = '$' + Number(exportDataRow.otherContentCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'Gross Profit';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = '$' + Number(exportDataRow.grossProfit).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'Gross Margin %';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = Number(exportDataRow.grossMarginPercentage).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%';
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'Share of Segment Revenue';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = Number(exportDataRow.shareSegmentRevenue).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%';
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'Share of Segment Profit';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = Number(exportDataRow.shareSegmentProfit).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%';
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'Output';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = Number(exportDataRow.articleCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'Daily Output';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = Number(exportDataRow.dailyOutput).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'Daily Sessions';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = Number(exportDataRow.dailySessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'Failure Rate';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = Number(exportDataRow.failureRate).toLocaleString('en-EG', {minimumFractionDigits: 1, maximumFractionDigits: 1}) + '%';
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'SV';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = '$' + Number(exportDataRow.sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'C/A';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = '$' + Number(exportDataRow.costPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
        exportDataView.push(exportDataViewRow);

        exportDataViewRow = [];
        exportDataViewRow[''] = 'ROI';
        for (let exportDataRow of reportData) {

            exportDataViewRow[exportDataRow.segmentName] = Number(exportDataRow.grossROI).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%';
        }
        exportDataView.push(exportDataViewRow);

        let fileName = "segmentReport_PL_data_from_" + this.datesFilter.getTemplateViewModel().startDate() + "_to_" + this.datesFilter.getTemplateViewModel().endDate()+ ".csv";
        this.exportReportDataCsv.exportToCsv(fileName, exportDataView);

        this.getTemplateViewModel().exportDataButtonClickable(1);
    }

    private getFormatedExportRow(exportDataRow) {

        let exportDataViewRow = [];

        exportDataViewRow["Day"] = exportDataRow.Day;

        for(let i=0; i < exportDataRow.segmentData.length; i++){

            exportDataViewRow['"' + exportDataRow.segmentData[i].segmentName + '"'] = '$' + Number(exportDataRow.segmentData[i].activeRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }

        exportDataViewRow["Art."] = Number(exportDataRow.articleCount).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Act. Sess./Art."] = Number(exportDataRow.activeSessionsPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["Act. Revenue"] = '$' + Number(exportDataRow.activeRevenue).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["SV"] = '$' + Number(exportDataRow.sv).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["Rev./Art."] = '$' + Number(exportDataRow.revenuePerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["Writer Cost"] = '$' + Number(exportDataRow.writerCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["Editor Cost"] = '$' + Number(exportDataRow.editorCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["Other Content Cost"] = '$' + Number(exportDataRow.otherContentCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["Total Cost"] = '$' + Number(exportDataRow.totalCost).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["C/A"] = '$' + Number(exportDataRow.costPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["GP/A"] = '$' + Number(exportDataRow.grossProfitPerArticle).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});
        exportDataViewRow["Act. Gross ROI%"] = Number(exportDataRow.activeGrossROI).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0}) + '%';
        exportDataViewRow["Act. Pageviews"] = Number(exportDataRow.activePageviews).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["Act. Sessions"] = Number(exportDataRow.activeSessions).toLocaleString('en-EG', {minimumFractionDigits: 0, maximumFractionDigits: 0});
        exportDataViewRow["PG/S"] = Number(exportDataRow.pageviewsPerSession).toLocaleString('en-EG', {minimumFractionDigits: 2, maximumFractionDigits: 2});

        return exportDataViewRow;
    }

    public hideExportButton(){

        this.getTemplateViewModel().exportButtonHidden(1);
        this.getTemplateViewModel().collapseButtonHidden(1);
    }

    public showExportButton(){

        this.getTemplateViewModel().exportButtonHidden(0);
        this.getTemplateViewModel().collapseButtonHidden(0);
    }

    private onFormOptionChange(selectedRevenueOption){

        this.caller.getListData();
    }

    /**
     * @inheritDoc
     */
    public setViewModelFromRequest(params : Array<any>): void{

        if(typeof params['viewMode'] !== 'undefined'){

            this.getTemplateViewModel().viewModeSelected(params['viewMode']);
        }

        if(typeof params['viewModeText'] !== 'undefined'){

            this.getTemplateViewModel().viewModeSelectedText(params['viewModeText']);
        }

        if(typeof params['brand'] !== 'undefined'){

            this.brandFilter.getTemplateViewModel().selectedOption(params['brand']);
            this.setBrandSegments(false);
        }

        this.presetFilter.setMultiSelectorPresetFilters(this.brandSegmentsFilter, params['brandSegments']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postInitiativesFilter, params['postInitiatives']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postPaymentCategorySystemFilter, params['postPaymentCategorySystems']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postIntentsFilter, params['postIntents']);
        this.presetFilter.setMultiSelectorPresetFilters(this.postContentTypesFilter, params['postContentTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.articleTypesFilter, params['articleTypes']);
        this.presetFilter.setMultiSelectorPresetFilters(this.networkCategoriesFilter, params['networkCategories']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.primaryCategoriesFilter, params['idPrimaryCategories'], params['namePrimaryCategories']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.srEditorsFilter, params['srEditors'], params['srEditorNames']);
        this.presetFilter.setMultipleAutocompletePresetFilter(this.jrEditorsFilter, params['jrEditors'], params['jrEditorNames']);


        if(typeof params['dataRange'] !== 'undefined'){

            this.getTemplateViewModel().dataRangeSelected(params['dataRange'])
            this.initializeToolTips();
        }

        if(typeof params['postContentTypesGroup'] !== 'undefined') {

            this.getTemplateViewModel().formOptionSelected(params['postContentTypesGroup']);
        }

        if(typeof params['publishStatus'] !== 'undefined'){

            this.getTemplateViewModel().publishStatusSelected(params['publishStatus']);
        }

        if(typeof params['trafficSource'] !== 'undefined'){

            this.getTemplateViewModel().trafficSource(params['trafficSource']);
        }

        this.presetFilter.setDates(this.datesFilter, params['dateFilterType'], params['startDate'], params['endDate'], params['startDateRange'], params['endDateRange']);
        this.presetFilter.setDates(this.plDatesFilter, params['plDateFilterType'], params['plStartDate'], params['plEndDate'], params['plStartDateRange'], params['plEndDateRange']);
    }

    public calculateColumnCount(){

        let overviewSectionColumnCount = 12;
        if (this.getTemplateViewModel().collapseButtonText() == 'simplify') {

            overviewSectionColumnCount += 3;
        }

        this.getTemplateViewModel().overviewSectionColumnCount(overviewSectionColumnCount);
    }

    public setDataRangesItems(){

        this.getTemplateViewModel().dataRanges(this.dataRanges);
    }


    public setBrandsItems(brands){

        this.getTemplateViewModel().brands(brands);
    }

    public setViewModesItems() {

        this.getTemplateViewModel().viewModes(this.viewModes);
    }

    private onDataRangeChange(data){

        this.initializeToolTips();
        this.caller.getListData();
    }

    public setPrimaryCategoriesFilterItems(items){

        this.primaryCategoriesFilter.setItems(items);
    }

    public setSrEditorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.srEditorsFilter.setItems(items);
    }

    public setJrEditorsFilterItems(items){

        for (let item of items){

            item['name'] = item['fullName'] + " (" + item['loginName'] + ")";
            item['iconImage'] = item['isActive'] == 1 ? 'is-user-is-active' : 'is-user-is-inactive';
        }
        items.unshift({'id': 0, 'name' : 'null'});
        this.jrEditorsFilter.setItems(items);
    }

    private onPublishStatusChange(){

        this.caller.getListData();
    }

    private onViewModeChange(selectedViewMode) {

        this.getTemplateViewModel().viewModeSelectedText(selectedViewMode.name);
        this.caller.getListData();
    }

    private onClickRowClick(index){

        let selectedRows = this.getTemplateViewModel().selectedRows();
        let check = selectedRows.indexOf(index);

        if (check !== -1) {

            selectedRows.splice(check, 1);
        }else {

            selectedRows.push(index);
        }

        this.getTemplateViewModel().selectedRows(selectedRows);
    }

    public resetSelectedRows(){

        this.getTemplateViewModel().selectedRows([]);
    }

    public activateGraphLoading(){

        this.getTemplateViewModel().isGraphLoading(1);
    }

    public deactivateGraphLoading(){

        this.getTemplateViewModel().isGraphLoading(0);
    }

    public updateGraphData(data) {

        this.updateLineGraphData(data);
        this.updatePieChartData(data);
    }

    public updatePieChartData(data){

        let chart = am4core.create("segmentPieChart", am4charts.PieChart);

        chart.svgContainer.htmlElement.style.height = "320px"; // Adjust height dynamically

        let chartData = [];
        for (let i = 0; i < data.reportTotalsData[0].segmentData.length; i++){

            let row = [];
            row['colour'] = segmentReport_template.stringToColour(data.reportTotalsData[0].segmentData[i]['segmentName']);
            row['activeSessions'] = data.reportTotalsData[0].segmentData[i]['activeSessions'];
            row['segmentName'] = data.reportTotalsData[0].segmentData[i]['segmentName'];
            chartData.push(row);
        }

        // Sort the values so that the pieces do not alternate between big and small randomly.
        chartData.sort((a,b) => a.activeSessions - b.activeSessions);

        chart.data = chartData;

        // Add and configure Series
        var pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.dataFields.value = "activeSessions";
        pieSeries.dataFields.category = "segmentName";
        pieSeries.slices.template.propertyFields.fill = "colour";

        pieSeries.labels.template.paddingTop = 0;
        pieSeries.labels.template.paddingBottom = 0;
        
        chart.radius = am4core.percent(80);
        if(chart.logo){

            chart.logo.disabled = true;
        }        
    }

    public updateLineGraphData(data){

        this.chart.setDate("Day");
        this.chart.setAutoRotateLabels(1);
        this.chart.setLabelMaxWidth(80);

        // set xaxis
        let yaxis = [];
        for (let i = 0; i < data.segmentHeaders.length; i++){

            let field = data.segmentHeaders[i].idSegment + '_activeSessions';
            let filedName = data.segmentHeaders[i].segmentName;

            let colour = segmentReport_template.stringToColour(filedName);

            yaxis.push({
                field: field,
                name: filedName,
                axis: "main",
                color: colour,
                opposite: false
            });
        }

        this.chart.setYaxis(yaxis);

        let chart = this.chart.drawChart(data.graphData);

        chart.legend.scrollable = true;
        chart.legend.position = 'right';
        chart.legend.labels.template.wrap = true

        let dateAxis = chart.xAxes.values[0];

        if (dateAxis instanceof DateAxis) {

            dateAxis.tooltipDateFormat = "EEEE, yyyy-MM-dd";
        }
        if(chart.logo){

            chart.logo.disabled = true;
        }        
    }

    /**
     * Convert a string into a colour. Used to pick a colour procedurally when a chart has a variable number of lines.
     */
    static stringToColour(str){

        let hash = 0;
        for (let i = 0; i < str.length; i++){

            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }

        let colour = '#';
        for (let i = 0; i < 3; i++){

            let value = (hash >> (i * 8)) & 0xFF;
            colour += ('00' + value.toString(16)).substr(-2);
        }

        return colour;
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/segmentReport_template.ts